module.exports = __webpack_public_path__ + "img/service1.d27cf9d9.png";